import { loader } from 'graphql.macro'

export default async function updateTicketBillingStatus ({ dataLoaders, variables }) {
  const schema = loader('./updateTicketBillingStatus.graphql')
  const response = await dataLoaders.dispatcher.graphQLClient.request(schema, { input: variables })
  return response.updateTicketBillingStatus
}
